/* eslint-disable no-underscore-dangle */
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import ReactGA from "react-ga4"
import initialiseHeap from "./initialiseHeap"

type TrackingIdsType = {
  dev: string
  test: string
  prod: string
}

declare const __ENVIRONMENT_TYPE__: keyof TrackingIdsType

const trackingIds: TrackingIdsType = {
  dev: "G-F765DGZWJL",
  test: "G-BMQZKB0P1X",
  prod: "G-6XDVYS3MQ8",
}

const AnalyticsManagement = (): null => {
  const location = useLocation()

  useEffect(() => {
    if (__ENVIRONMENT_TYPE__ === "dev") initialiseHeap()
    const trackingId = trackingIds[__ENVIRONMENT_TYPE__]
    if (trackingId) ReactGA.initialize([{ trackingId }])
    else console.error("No tracking ID found")
  }, [])

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      title: location.pathname,
    })
  }, [location])

  return null
}

export default AnalyticsManagement
